var render = function () {
  var _vm$profile, _vm$profile$item_id;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-4"
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Books',
        to: '/ebooks'
      }, {
        label: ("Bulk Upload File  " + (this.slug))
      }],
      "title": ("Bulk Upload File " + (this.slug))
    }
  }), this.files.length === 0 ? _c('div', {
    staticClass: "bg-white rounded-md shadow-sm flex-col w-full"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".pdf,.epub"
    },
    on: {
      "change": _vm.handleFiles
    }
  }), _c('div', {
    staticClass: "flex justify-between w-full"
  }, [_vm._m(0), _c('div', {
    staticClass: "px-4 mt-4",
    class: {
      'disabled opacity-50 pointer-events-none': ((_vm$profile = _vm.profile) === null || _vm$profile === void 0 ? void 0 : (_vm$profile$item_id = _vm$profile.item_id) === null || _vm$profile$item_id === void 0 ? void 0 : _vm$profile$item_id.role_id) === 5
    }
  }, [_c('router-link', {
    staticClass: "text-gray-500 hover:no-underline hover:text-gray-500",
    attrs: {
      "to": ("/items/bulk/log_activity/" + (_vm.slug))
    }
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    }
  }, [_c('svg', {
    staticClass: "w-4 h-4 mr-1 text-gray-500",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"
    }
  })]), _vm._v(" View History ")])], 1)], 1)]), _c('div', {
    staticClass: "flex justify-start w-full px-4 py-3"
  }, [this.files.length === 0 ? _c('div', {
    staticClass: "mr-2.5"
  }, [_c('div', {
    staticClass: "bg-gray-50 dropzone-style justify-center items-center flex",
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
      },
      "dragenter": function ($event) {
        $event.preventDefault();
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleDrop.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-content flex justify-center items-center flex-col"
  }, [_c('div', {
    staticClass: "icon mb-2"
  }, [_c('svg', {
    staticClass: "w-7 h-7 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12 3a1 1 0 0 1 .78.375l4 5a1 1 0 1 1-1.56 1.25L13 6.85V14a1 1 0 1 1-2 0V6.85L8.78 9.626a1 1 0 1 1-1.56-1.25l4-5A1 1 0 0 1 12 3ZM9 14v-1H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v1a3 3 0 1 1-6 0Zm8 2a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z",
      "clip-rule": "evenodd"
    }
  })])]), _c('p', {
    staticClass: "text-sm text-gray-500 m-0"
  }, [_vm._v(" Drag & drop files PDF or EPUB ")]), _c('a', {
    staticClass: "text-xs text-blue-600 underline",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$refs.fileInput.click();
      }
    }
  }, [_vm._v(" or browse for files ")]), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".pdf,.epub",
      "hidden": ""
    },
    on: {
      "change": _vm.handleFiles
    }
  })])])]) : _vm._e(), this.files.length === 0 ? _c('div', {
    staticClass: "w-full ml-2.5"
  }, [_vm._m(1)]) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "flex-col justify-start items-center p-4 bg-white shadow-md rounded-xl"
  }, [_vm._m(2), _c('div', {
    staticClass: "w-full flex-col border rounded-xl"
  }, [_vm.files.length > 0 ? _c('Table', {
    staticClass: "table-bulk",
    attrs: {
      "headers": _vm.headers,
      "data": this.files,
      "withAction": true,
      "withNumberCol": false,
      "row-key": ['name_file', 'size', 'format', 'content_id'],
      "current-page": _vm.currentPage,
      "isLoading": false,
      "per-page": 20
    },
    scopedSlots: _vm._u([{
      key: "name_file",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('p', {
          staticClass: "w-80"
        }, [_vm._v(_vm._s(value))])];
      }
    }, {
      key: "content_id",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('div', {
          staticClass: "flex justify-start items-baseline w-full"
        }, [_c('div', {
          staticClass: "block w-full"
        }, [_c('ContentDropdown', {
          attrs: {
            "items": _vm.contentList,
            "selected": row.matched_content,
            "error": !!row.error_content_id
          },
          on: {
            "select": function ($event) {
              return _vm.updateContent(row, $event);
            },
            "search": _vm.searchContent
          }
        }), row.error_content_id ? _c('p', {
          staticClass: "mt-2 text-xs text-red-500 lowercase"
        }, [_vm._v(" " + _vm._s(row.error_content_id) + " ")]) : _vm._e()], 1), _c('div', {
          staticClass: "w-auto relative top-1 left-9",
          on: {
            "click": function ($event) {
              return _vm.removeFile(row);
            }
          }
        }, [_c('svg', {
          staticClass: "w-5 h-5 text-gray-800 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
          }
        })])])])];
      }
    }], null, false, 3025867754)
  }) : _vm._e()], 1)])]), this.files.length > 0 ? _c('div', {
    staticClass: "flex justify-start space-x-4 mt-8 p-4 items-center bg-white rounded-lg"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    class: {
      'opacity-50': _vm.isSubmitting
    },
    attrs: {
      "disabled": _vm.isSubmitting,
      "variant": "default",
      "color": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.openPopup
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmitting ? 'Loading...' : 'Submit') + " ")]), _c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Cancel ")])], 1) : _vm._e(), _c('t-modal', {
    ref: "confirmationModal"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center"
  }, [_c('label', {
    staticClass: "text-center font-semibold"
  }, [_vm._v("Do you want to continue?")]), _c('p', {
    staticClass: "text-center text-gray-500"
  }, [_vm._v("This action will update book content.")])]), _c('div', {
    staticClass: "flex justify-center space-x-3"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "default",
      "color": "primary",
      "size": "xs"
    },
    on: {
      "click": _vm.uploadAll
    }
  }, [_vm._v(" Continue ")]), _c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.cancelpopup
    }
  }, [_vm._v(" Cancel ")])], 1)]), _vm.showToast ? _c('div', {
    staticClass: "fixed top-20 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-6 py-3 rounded-xl shadow-lg flex items-center justify-between toast-width z-50 transition-all duration-300 translate-y-0 opacity-100"
  }, [_c('span', [_vm._v("Upload in progress. Please wait.")]), _c('Button', {
    staticClass: "hover:text-gray-800",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push(("/items/bulk/log_activity/" + (_vm.slug)));
      }
    }
  }, [_vm._v(" View History ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-4 mt-4"
  }, [_c('h2', {
    staticClass: "text-base font-semibold text-gray-900 mb-0"
  }, [_vm._v(" Upload your files")]), _c('p', {
    staticClass: "text-gray-500 text-sm pt-0 mb-0 leading-8"
  }, [_vm._v("Select or drag one or more files into the box to start uploading.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-blue-custom bg-blue-50 rounded-xl p-0 text-blue-900 max-w-2xl"
  }, [_c('div', {
    staticClass: "flex items-start gap-0 rounded-lg p-3"
  }, [_c('img', {
    staticClass: "w-4 h-5 mr-1 mt-1",
    attrs: {
      "src": require("../../assets/img/info.svg")
    }
  }), _c('div', [_c('p', {
    staticClass: "font-semibold ml-1 text-lg mb-0"
  }, [_vm._v(" Before you upload. Make matching easier. ")]), _c('ol', {
    staticClass: "list-decimal ml-0 space-y-1 mb-0 text-sm"
  }, [_c('li', [_vm._v(" Rename your files using the "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Content ID")]), _vm._v(" to make matching faster. ")]), _c('li', [_vm._v(" Check file size — max "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("100 MB")]), _vm._v(". ")]), _c('li', [_vm._v(" Supported formats: "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("PDF")]), _vm._v(" and "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("EPUB")]), _vm._v(" only. ")]), _c('li', [_vm._v(" Maximum upload: "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("20 files")]), _vm._v(" at once. ")])])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-0"
  }, [_c('h2', {
    staticClass: "text-base font-semibold text-gray-900 mb-0"
  }, [_vm._v("Double-Check File Name and ID")]), _c('p', {
    staticClass: "text-gray-500 text-sm pt-0 mb-3 leading-8"
  }, [_vm._v("Double-check file names and select the correct Content ID for each file to ensure accurate updates.")])]);
}]

export { render, staticRenderFns }